import React from "react";
import { motion } from "framer-motion";
export default function PriorHintergration() {
  const integrationCategories = [
    {
      category: "EHR & Clinical Core Systems",
      badge: "FHIR R4 / SMART",
      description:
        "Bi-directional connectivity to electronic health records via CDS Hooks and SMART-on-FHIR apps to retrieve clinical bundles right at the point of care.",
      partners: [
        { name: "Epic Systems", spec: "App Orchard / FHIR R4", type: "EHR" },
        { name: "Oracle Health (Cerner)", spec: "Millennium Ignite API", type: "EHR" },
        { name: "Athenahealth", spec: "MDR & REST FHIR", type: "EHR" },
        { name: "MEDITECH", spec: "Expanse Interoperability", type: "EHR" },
      ],
    },
    {
      category: "Payer Platforms & Clearinghouses",
      badge: "X12 & Da Vinci PAS",
      description:
        "Direct routing into commercial, Medicare Advantage, and state Medicaid core adjudication platforms with automatic X12 278 to FHIR Claim translation.",
      partners: [
        { name: "Change Healthcare", spec: "Claim Clearinghouse", type: "PAYER GATEWAY" },
        { name: "Availity", spec: "EDI 278 / Payer Gateway", type: "CLEARINGHOUSE" },
        { name: "Epic Tapestry", spec: "Managed Care Core", type: "PAYER CORE" },
        { name: "HealthEdge", spec: "Cloud Adjudication", type: "PAYER CORE" },
      ],
    },
    {
      category: "Orchestration & Interoperability Standards",
      badge: "ISO & HL7 Compliant",
      description:
        "Core protocol stack running under Camunda 8 Zeebe, executing automated DMN medical policy tables and continuous schema governance.",
      partners: [
        { name: "HL7® FHIR® R4", spec: "US Core 3.1.1+", type: "STANDARD" },
        { name: "Da Vinci Project", spec: "CRD • DTR • PAS", type: "SPECIFICATION" },
        { name: "Camunda 8 Zeebe", spec: "Event-Stream Engine", type: "ORCHESTRATION" },
        { name: "Clinical Quality Lang", spec: "Dynamic Rule Exec", type: "RULES ENGINE" },
      ],
    },
  ];

  return (
    <section className="relative w-full bg-[#F8FAFC]lg:py-24 md:py-16 py-10 border-b border-slate-200/80 font-sans overflow-hidden">
      <div className="mx-auto 3xl:w-4/5 lg:w-11/12 px-6 lg:px-12 z-10  ">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 pb-8 border-b border-slate-200">
          <div>
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: 0.05 }}
              className="inline-flex items-center gap-2 px-0.5 py-1.5 backdrop-blur-md shadow-xs mb-4"
            >
              <span className="text-[11px] font-bold uppercase tracking-[0.2em] text-slate-700">
                INTEROPERABILITY FABRIC
              </span>
            </motion.div>
            <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-slate-950">
              EHR &amp; Payer{" "}
              <span className="italic font-serif font-normal text-[#5dc9f0]">
                Ecosystem
              </span>
            </h2>
          </div>  
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mt-16 items-stretch">
          {integrationCategories.map((cat, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: idx * 0.1 }}
              className="bg-white border border-slate-200/90 rounded-xl p-4 md:p-8 flex flex-col justify-between shadow-sm hover:border-slate-300 hover:shadow-lg hover:shadow-slate-200/40 transition-all duration-300"
            >
              <div className="space-y-6">
                <div className="flex items-center justify-between border-b border-slate-100 pb-4">
                  <span className="text-[11px] font-mono font-bold uppercase tracking-wider text-gray-500  px-2.5 py-1 rounded-md ">
                    {cat.badge}
                  </span>                  
                </div>
                <div className="space-y-2">
                  <h3 className="text-xl font-bold text-[#000036] tracking-tight">
                    {cat.category}
                  </h3>
                  <p className="text-sm  sm:text-base text-slate-600 font-normal leading-relaxed ">
                    {cat.description}
                  </p>
                </div>
                <div className="space-y-3 md:pt-2">
                  {cat.partners.map((partner, pIdx) => (
                    <div
                      key={pIdx}
                      className="md:p-3.5 p-2 rounded-xl bg-slate-50/80 border border-slate-100 hover:bg-white hover:border-slate-300 hover:shadow-xs transition-all flex items-center justify-between"
                    >
                      <div className="space-y-0.5">
                        <p className="text-sm font-bold text-[#000036] tracking-tight">
                          {partner.name}
                        </p>                       
                      </div>
                      <span className="font-mono text-xs uppercase tracking-wider font-semibold text-white bg-[#5dc9f0] px-2 py-0.5 rounded border border-slate-200">
                        {partner.type}
                      </span>
                    </div>
                  ))}
                </div>
              </div>              
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}